import { TApplicationState } from '../../types/redux';

export const selectIsStickyScrollBtnVisible = (state: TApplicationState) => {
  return state.page.stickyScrollBtnVisible;
};
